<template>
    <div class="input-control">
        <textarea :name="name" :spellcheck="spellcheck" @input="onInput"
                  ref="textarea" @blur="onTextareaBlurred"></textarea>
        <i v-if="locateButton && value" class="gf gf-pin locate-button" @click="locate"></i>
    </div>
</template>

<script>
    import InputControlBase from "@/InputControls/InputControlBase";

    export default {
        name: "TextArea",
        mixins: [InputControlBase],
        props: {
          spellcheck: {
            default: 'true'
          },
          locateButton: {
            default: false,
          }
        },
        created() {
            if (typeof this.value === 'undefined' || this.value === null) {
                this.value = '';
            }
        },
        mounted() {
            this.repaintUI();
        },
        methods: {
            repaintUI() {
                this.$refs.textarea.value = this.value;
            },
            onInput(event) {
                const oldVal = event.currentTarget.value;
                const newVal = oldVal.replace(/\n{3,}/g, '\n\n');
                this.value = newVal;
                event.currentTarget.value = newVal;
            },
            setInputValue(value) {
                this.value = value;
                this.repaintUI();
            },
            focus() {
                this.$refs.textarea.focus();
            },
            onTextareaBlurred() {
                if (this.value !== null && this.value.constructor === String) {
                    this.value = this.value.trim();
                }
                this.repaintUI();
            },
            locate() {
                this.$emit('highlightTextInViewerForItem', {context: this.value});
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "input-controls";

    textarea {
        width: 100%;
        resize: vertical;
        line-height: 1rem;
        height: calc(3rem + 2px);
        min-height: calc(3rem + 2px);
    }

    .input-control {
        position: relative;

        &:hover {
            .locate-button {
                opacity: 0.5;
            }
        }

        .locate-button {
            font-size: 0.86em;
            background: #e0e0e0;
            padding: 2px 0.4rem;
            border-radius: 4px;
            position: absolute;
            right: 2px;
            top: 2px;
            opacity: 0;
            color: #333333;

            &:hover {
                opacity: 1;
            }
        }
    }

</style>
